import React from 'react';
import './DoctorDetails.css';

const DoctorDetails = () => {

    return (
        <div>
            <h1>We working on it</h1>
            <img className="image w-50" src="https://i.ibb.co/7g05N7q/Working-late-amico.png"alt="" />
            
        </div>
    );
};

export default DoctorDetails;